import { render, staticRenderFns } from "./CopyIcon.vue?vue&type=template&id=2e40887c&scoped=true&"
import script from "./CopyIcon.vue?vue&type=script&lang=js&"
export * from "./CopyIcon.vue?vue&type=script&lang=js&"
import style0 from "./CopyIcon.vue?vue&type=style&index=0&id=2e40887c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e40887c",
  null
  
)

export default component.exports